// deprecated in favor of useTabs.js
// (requires a switch from createReactClass to hooks)

/* global isMobileView scrollToPageTop toast Uri */

export const TabsMixin = {

    initialLoad: true,

    requestDataAndScroll: function (apiUrl) {
        $.ajax({
            url: apiUrl,
            cache: true,
            dataType: 'json',
            success: this.handleResponse,
            error: (jqXHR, status, error) => {
                toast('There was a problem loading more results. Please try again later.');
                this.setState({
                    loading: false,
                });
            },
        });

        if (this.initialLoad) {
            this.initialLoad = false;
        } else if (!isMobileView()) {
            // we need to account for the floating give bar
            if ($('#tabs').is(':visible')) {
                scrollToPageTop($('#tabs').offset().top - 100);
            } else {
                scrollToPageTop(0);
            }
        }
    },

    /**
     * Changes the page URL and loads the relevant data.
     * Both params have the same use, but it's designed so it can be called
     * in response to a trigger, which passes the event as the first param.
     */
    changeURL: function (url, otherUrl) {
        if (this.state.loading) {
            return;
        }
        url = otherUrl || url;
        const tabName = this.getTabName(url);
        this.setState({
            activeTabName: tabName,
            url: url,
            loading: true,
        });
        history.replaceState(null, null, url);
        this.requestData(this.state.validTabs.get(tabName), url);
    },

    /* Activates a tab and loads its data.
    * Both params have the same use, but it's designed so it can be called
    * in response to a trigger, which passes the event as the first param.
    */
    activateTab: function (otherTabName, tabName) {
        tabName = tabName || otherTabName;

        const state = this.state;
        const newTab = state.validTabs.get(tabName);

        const url = new Uri(state.url)
            .delete('page')
            .delete('active')
            .delete('historical')
            .delete('projects') // [BGK, 2016-12-13: currently only used for Teacher Profile tabs]
            .delete('fundedProjectsYear') // unique to Projects tab on Teacher Profile page
            .delete('supporters')
            .add(newTab.get('paramName'), 'true');

        this.changeURL(url.toString());
    },

    closeTab: function () {
        this.setState({
            activeTabName: null,
            data: null,
        });
    },

    componentDidMount: function () {
        $(window).on('tabChanged', this.activateTab);
        $(window).on('changeURL', this.changeURL);
        $(window).on('closeTab', this.closeTab);
    },

};
